export const age = [ 
    {},
    {label: 'Under 20', value: 'Under 20'}, 
    {label: '20-29', value: '20-29'}, 
    {label: '30-39', value: '30-39'}, 
    {label: '40-49', value: '40-49'}, 
    {label: '50+', value: '50+'}
]